import {match} from 'ts-pattern';

import {sortBy} from 'ramda';

import type {EagColumnState} from '../../types/EagColumnState';
import {withColumnStatesCache} from './withColumnStatesCache';

const byOrder = (column: EagColumnState) => column.order;

/** Shared display order: pinned left, unpinned, pinned right, with hidden columns omitted. */
export const selectOrderedVisibleColumns = withColumnStatesCache((columnStates) => {
  const pinnedLeft: EagColumnState[] = [];
  const unpinned: EagColumnState[] = [];
  const pinnedRight: EagColumnState[] = [];

  for (const column of columnStates.filter((state) => state.hidden !== true)) {
    match(column.pinned)
      .with('LEFT', () => pinnedLeft.push(column))
      .with('RIGHT', () => pinnedRight.push(column))
      .otherwise(() => unpinned.push(column));
  }

  return [
    ...sortBy(byOrder, pinnedLeft),
    ...sortBy(byOrder, unpinned),
    ...sortBy(byOrder, pinnedRight),
  ];
});
